import { Accessor, createSignal } from "solid-js";
import TataUserInfoModal from "~/components/login-rnr/tata_user_info_modal";
import { closeAllModals, openModalV2 } from "~/shared_states/modal";
import { Optional } from "~/types";

export default function useTataUserInfoModal() {
  const [showLoader, setShowLoader] = createSignal<boolean>(false);
  const [errors, setErrors] = createSignal<{ [key: string]: string }>({});

  const openModal = (props: {
    isOfferConstructAvailable: boolean;
    offerConstructType: "ONE_TIME_REWARD" | "SUBSCRIPTION_REWARD" | undefined;
    offerConstructTenure: any;
    clientLogoUrl?: string;
    redemptionAmount: any;
    dueAmount: Accessor<Optional<number>>;
    brandDetails?: any;
    selectedAmount: any;
    email: string | null;
    phone: string | null;
    name: string | null;
    onClickSubmit: (profileUpdateParams: any) => void;
    subtitle: string;
  }) => {
    openModalV2(() => {
      return (
        <TataUserInfoModal
          isOfferConstructAvailable={props.isOfferConstructAvailable}
          offerConstructType={props.offerConstructType}
          offerConstructTenure={props.offerConstructTenure}
          clientLogoUrl={props.clientLogoUrl}
          redemptionAmount={props.redemptionAmount}
          dueAmount={props.dueAmount}
          brandDetails={props.brandDetails}
          selectedAmount={props.selectedAmount}
          email={props.email}
          phone={props.phone}
          name={props.name}
          onClickSubmit={props.onClickSubmit}
          subtitle={props.subtitle}
          setShowLoader={setShowLoader}
          showLoader={showLoader}
          errors={errors}
          setErrors={setErrors}
        />
      );
    });
  };

  async function closeModal() {
    await closeAllModals();
    setShowLoader(false);
    setErrors({});
  }

  return {
    openModal,
    showLoader,
    setShowLoader,
    closeModal,
  };
}
